<template>
	<div class="FilterList">
		<CheckBoxSelectItem
			v-for="item in items"
			:key="item.value"
			:item="item"
			@selectionChange="(state) => handleSelectionChange(item, state)"
		/>
	</div>
</template>

<script setup lang="ts">
import CheckBoxSelectItem from '@components/CheckBoxSelectItem/CheckBoxSelectItem.vue';
import { AttendanceFilterMapper } from '@app/routing/mappers/AttendanceFilterMapper';
import { useCheckboxFilter } from '@composables/useCheckboxFilter';
import { FilterType } from '@studyportals/omnisearch-interfaces';

const { items, handleSelectionChange } = useCheckboxFilter(
	AttendanceFilterMapper.getInstance(),
	FilterType.ATTENDANCE
);
</script>

<style scoped lang="scss">
.FilterList {
	width: 100%;
	padding-right: 2px;	// required for outline not to be cut off
}
</style>
